// // 02-11-2026 static code
// import React, { useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import "./PicksSection.css";

// /* ------------------------------------------------------------------
//    CARDS (static)
//    - image: abhi placeholder link hai. Apni images public/images/ mein
//      rakho aur comment wala path laga do, jaise "/images/fav1.jpg"
//      (portrait image best rahegi, jaise 800 x 1066)
//    - category_id / subcategory_id: detail page ka link isi se banta hai
//      (pehle jaisa): /products?category=ID&subcategory=ID
//      Apni asli ids yahan daal dena.
//    - Card kam/zyada karne ho to array mein object add/remove kar do.
//      Grid ek row mein 3 cards dikhata hai.
// ------------------------------------------------------------------- */
// const CARDS = [
//   {
//     title: "Tissue Sarees",
//     category_id: 2,
//     subcategory_id: 1,
//     image: "/img/favcoll1.webp",
//     // image: "/images/fav1.jpg",
//   },
//   {
//     title: "New Launch",
//     category_id: 2,
//     subcategory_id: 2,
//     image: "/img/favcoll2.webp",
//     // image: "/images/fav2.jpg",
//   },
//   {
//     title: "Cotton Collection",
//     category_id: 2,
//     subcategory_id: 3,
//     image: "/img/favcoll3.webp",
//     // image: "/images/fav3.jpg",
//   },
//   // {
//   //   title: "Linen Sarees",
//   //   category_id: 2,
//   //   subcategory_id: 4,
//   //   image: "https://placehold.co/800x1066/8a7b5c/fffbf7?text=Linen+Sarees",
//   //   // image: "/images/fav4.jpg",
//   // },
//   // {
//   //   title: "Banarasi Edit",
//   //   category_id: 2,
//   //   subcategory_id: 5,
//   //   image: "https://placehold.co/800x1066/7a2b2b/fffbf7?text=Banarasi+Edit",
//   //   // image: "/images/fav5.jpg",
//   // },
//   // {
//   //   title: "Festive Select",
//   //   category_id: 2,
//   //   subcategory_id: 6,
//   //   image: "https://placehold.co/800x1066/3d5a4a/fffbf7?text=Festive+Select",
//   //   // image: "/images/fav6.jpg",
//   // },
// ];

// const PicksSection = () => {
//   const headerRef = useRef(null);
//   const cardRefs = useRef([]);

//   /* Scroll par header + cards fade-in (pehle jaisa) */
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("favparatha-animate-in");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );

//     if (headerRef.current) observer.observe(headerRef.current);
//     cardRefs.current.forEach((el) => el && observer.observe(el));

//     return () => observer.disconnect();
//   }, []);

//   return (
//     <section className="favparatha-section">
//       <div className="favparatha-container">
//         <div className="favparatha-header" ref={headerRef}>
//           <p className="favparatha-subtitle">Experience Smiles &amp; Elegance</p>
//           <h2 className="favparatha-title">Your Favourite Collections</h2>
//         </div>

//         <div className="favparatha-grid">
//           {CARDS.map((card, index) => (
//             <Link
//               key={card.subcategory_id}
//               to={`/products?category=${card.category_id}&subcategory=${card.subcategory_id}`}
//               className="favparatha-card"
//               ref={(el) => (cardRefs.current[index] = el)}
//               style={{ "--favparatha-delay": `${(index % 3) * 100}ms` }}
//               aria-label={card.title}
//             >
//               <img
//                 src={card.image}
//                 alt={card.title}
//                 className="favparatha-img"
//                 loading="lazy"
//                 draggable={false}
//               />

//               <div className="favparatha-overlay">
//                 <h3 className="favparatha-card-title">{card.title}</h3>
//                 <span className="favparatha-btn">View Sarees</span>
//               </div>
//             </Link>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default PicksSection;











// // 04-11-2026 dynamic code
// import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
// import "./PicksSection.css";

// const API_URL =
//   "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_favourite_collections";

// /* API item -> card shape */
// const mapCard = (item) => ({
//   id: item.id,
//   title: item.heading,
//   image: item.image || item.image,
//   btnText: item.btn_text || "View Sarees",
//   // API mein category/subcategory aaye to use hoga, warna /products
//   // link:
//   //   item.category_id && item.subcategory_id
//   //     ? `/products?category=${item.category_id}&subcategory=${item.subcategory_id}`
//   //     : "/products",
  
//     link: item.category_slug
//     ? `/${item.category_slug}${
//         Number(item.subcategory_id) > 0
//           ? `?subcategory=${item.subcategory_id}`
//           : ""
//       }`
//     : "/all-sarees",
// });

// const PicksSection = () => {
//   const headerRef = useRef(null);
//   const cardRefs = useRef([]);

//   const [cards, setCards] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   /* ---------------- API fetch ---------------- */
//   useEffect(() => {
//     const controller = new AbortController();

//     const fetchCollections = async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const res = await fetch(API_URL, { signal: controller.signal });
//         if (!res.ok) throw new Error("Network response was not ok");
//         const json = await res.json();

//         const ok =
//           json?.success === "1" ||
//           json?.success === 1 ||
//           json?.status === "true" ||
//           json?.status === true;

//         if (!ok || !json.data) {
//           throw new Error(json?.message || "Failed to load collections");
//         }

//         // data array ho ya single object, dono handle
//         const list = Array.isArray(json.data) ? json.data : [json.data];

//         // A -> B: admin se jo pehla add hua wo pehle card par
//         const sorted = [...list].sort((a, b) => Number(a.id) - Number(b.id));
//         setCards(sorted.map(mapCard));
//       } catch (err) {
//         if (err.name !== "AbortError") {
//           setError("Something went wrong while loading collections.");
//         }
//       } finally {
//         if (!controller.signal.aborted) setLoading(false);
//       }
//     };

//     fetchCollections();
//     return () => controller.abort();
//   }, []);

//   /* Header fade-in (static heading, turant observe) */
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("favparatha-animate-in");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );

//     if (headerRef.current) observer.observe(headerRef.current);
//     return () => observer.disconnect();
//   }, []);

//   /* Cards fade-in (cards API se aane ke baad observe hote hain) */
//   useEffect(() => {
//     if (cards.length === 0) return;

//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             entry.target.classList.add("favparatha-animate-in");
//             observer.unobserve(entry.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );

//     cardRefs.current.forEach((el) => el && observer.observe(el));
//     return () => observer.disconnect();
//   }, [cards]);

//   return (
//     <section className="favparatha-section">
//       <div className="favparatha-container">
//         {/* Heading (static) */}
//         <div className="favparatha-header" ref={headerRef}>
//           <p className="favparatha-subtitle">Experience Smiles &amp; Elegance</p>
//           <h2 className="favparatha-title">Your Favourite Collections</h2>
//         </div>

//         {loading && <p>Loading...</p>}
//         {!loading && error && <p>{error}</p>}
//         {!loading && !error && cards.length === 0 && (
//           <p>No collections available.</p>
//         )}

//         {!loading && !error && cards.length > 0 && (
//           <div className="favparatha-grid">
//             {cards.map((card, index) => (
//               <Link
//                 key={card.id}
//                 to={card.link}
//                 className="favparatha-card"
//                 ref={(el) => (cardRefs.current[index] = el)}
//                 style={{ "--favparatha-delay": `${(index % 3) * 100}ms` }}
//                 aria-label={card.title}
//               >
//                 <img
//                   src={card.image}
//                   alt={card.title}
//                   className="favparatha-img"
//                   loading="lazy"
//                   draggable={false}
//                 />

//                 <div className="favparatha-overlay">
//                   <h3 className="favparatha-card-title">{card.title}</h3>
//                   <span className="favparatha-btn">{card.btnText}</span>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default PicksSection;









// 04-11-2026 dynamic code
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./PicksSection.css";

const API_URL =
  "https://cyberathon.com/streekatha/API/index.php/Master_controller/list_z_favourite_collections";

/* API item -> card shape */
const mapCard = (item) => ({
  id: item.id,
  title: item.heading,
  // API 'image' field me direct full URL return karta hai (base_url se)
  image: item.image_url || item.image,
  btnText: item.btn_text || "View Sarees",
  // API mein category/subcategory aaye to use hoga, warna /all-sarees
  link: item.category_slug
    ? `/${item.category_slug}${
        Number(item.subcategory_id) > 0
          ? `?subcategory=${item.subcategory_id}`
          : ""
      }`
    : "/all-sarees",
});

const PicksSection = () => {
  const headerRef = useRef(null);
  const cardRefs = useRef([]);

  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ---------------- API fetch ---------------- */
  useEffect(() => {
    const controller = new AbortController();

    const fetchCollections = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(API_URL, { signal: controller.signal });
        if (!res.ok) throw new Error("Network response was not ok");
        const json = await res.json();

        // API dono formats support karta hai:
        // 1) { status: "success", data: [...] }  (streekatha wala)
        // 2) { success: "1"/1, data: [...] }
        // 3) { status: "true"/true, data: [...] }
        const ok =
          json?.status === "success" ||
          json?.success === "1" ||
          json?.success === 1 ||
          json?.status === "true" ||
          json?.status === true;

        if (!ok || !json.data) {
          throw new Error(json?.message || "Failed to load collections");
        }

        // data array ho ya single object, dono handle
        const list = Array.isArray(json.data) ? json.data : [json.data];

        // A -> B: admin se jo pehla add hua wo pehle card par
        const sorted = [...list].sort((a, b) => Number(a.id) - Number(b.id));
        setCards(sorted.map(mapCard));
      } catch (err) {
        if (err.name !== "AbortError") {
          setError("Something went wrong while loading collections.");
        }
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };

    fetchCollections();
    return () => controller.abort();
  }, []);

  /* Header fade-in (static heading, turant observe) */
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("favparatha-animate-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headerRef.current) observer.observe(headerRef.current);
    return () => observer.disconnect();
  }, []);

  /* Cards fade-in (cards API se aane ke baad observe hote hain) */
  useEffect(() => {
    if (cards.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("favparatha-animate-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    cardRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [cards]);

  return (
    <section className="favparatha-section">
      <div className="favparatha-container">
        {/* Heading (static) */}
        <div className="favparatha-header" ref={headerRef}>
          <p className="favparatha-subtitle">Experience Smiles &amp; Elegance</p>
          <h2 className="favparatha-title">Your Favourite Collections</h2>
        </div>

        {loading && <p>Loading...</p>}
        {!loading && error && <p>{error}</p>}
        {!loading && !error && cards.length === 0 && (
          <p>No collections available.</p>
        )}

        {!loading && !error && cards.length > 0 && (
          <div className="favparatha-grid">
            {cards.map((card, index) => (
              <Link
                key={card.id}
                to={card.link}
                className="favparatha-card"
                ref={(el) => (cardRefs.current[index] = el)}
                style={{ "--favparatha-delay": `${(index % 3) * 100}ms` }}
                aria-label={card.title}
              >
                <img
                  src={card.image}
                  alt={card.title}
                  className="favparatha-img"
                  loading="lazy"
                  draggable={false}
                />

                <div className="favparatha-overlay">
                  <h3 className="favparatha-card-title">{card.title}</h3>
                  <span className="favparatha-btn">{card.btnText}</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PicksSection;
